<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
    style="max-width: 100%"
    >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <img v-if="logo" style="max-width: 120px" :src="logoW">
        <img v-if="!logo" style="max-width: 120px" :src="logoO">
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <md-list-item
                href="javascript:void(0)"
                @click="scrollToElement('homeSection')"
                class="hover-element"
              >
                <p>Home</p>
              </md-list-item>
              <md-list-item
                href="javascript:void(0)"
                @click="scrollToElement('productSection')"
                class="hover-element"
              >
                <p>Produtos</p>
              </md-list-item>
              <md-list-item
                href="javascript:void(0)"
                @click="scrollToElement('tecnoSection')"
                class="hover-element"
              >
                <p>Tecnologia</p>
              </md-list-item>
              <md-list-item
                href="javascript:void(0)"
                @click="scrollToElement('contactSection')"
                class="hover-element"
              >
                <p>Contato</p>
              </md-list-item>

              <md-list-item
                href="https://edex.com.br/platform/index.php"
                class="hover-element"
              >
                <p>Login</p>
              </md-list-item>

              <md-list-item
                href="https://www.facebook.com/profile.php?id=100007791135794"
                target="_blank"
              >
                <i class="fab fa-facebook-square"></i>
                <p class="hidden-lg">Facebook</p>
                <md-tooltip md-direction="bottom"
                  >Nos siga no Facebook!</md-tooltip
                >
              </md-list-item>
              <md-list-item
                href="https://www.linkedin.com/company/edexconfec%C3%A7%C3%B5es/"
                target="_blank"
              >
                <i class="fab fa-linkedin"></i>
                <p class="hidden-lg">Linkedin</p>
                <md-tooltip md-direction="bottom"
                  >Nos siga no Linkedin!</md-tooltip
                >
              </md-list-item>

              
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
/* eslint-disable */
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    logoW: {
      type: String,
      default: require("@/assets/img/logo_white.png")
    },
    logoB: {
      type: String,
      default: require("@/assets/img/logo_black.png")
    },
    logoO: {
      type: String,
      default: require("@/assets/img/logo_orange.png")
    },
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
      logo: true
    };
  },
  methods: {
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
        this.logo = false
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
          this.logo = true
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement(element) {
      let element_id = document.getElementById(element);
      if (element_id) {
        element_id.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  }
};
</script>
<style>
.hover-element:hover{
  margin: 0px 10px;
  transition: all 0.5s
}
</style>